import {isNil, omitBy} from 'lodash-es'
import type {KeyTuple} from 'types/util'

export function queryKeysFromParams<T>(
  params: {[s: string]: T} | ArrayLike<T>
): KeyTuple {
  return Object.entries(omitBy(params, isNil)) as KeyTuple
}
